import { useRouter } from 'next/router';
import React from 'react';
import { VideoEntry } from 'app/components/DetailsPage/VideoEntry';
import NotFound from 'lib/deepLink/NotFound';

const VideoPage = () => {
    const router = useRouter();

    const querySlug = typeof router.query?.slug === 'object' ? router.query?.slug : [];
    const path = `/${querySlug.join('/')}`;

    if (querySlug.length > 0) {
        return <VideoEntry path={path} />;
    }

    return <NotFound />;
};

export default VideoPage;
